/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListAuthClientsResponseBody,
  ListAuthClientsResponseBody$inboundSchema,
} from "../components/listauthclientsresponsebody.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListAuthClientsSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

/**
 * Only clients of this type.
 */
export const ClientType = {
  RemoteSession: "remote_session",
  ServiceAccount: "service_account",
  StaticCredential: "static_credential",
  PassThrough: "pass_through",
  Ema: "ema",
} as const;
/**
 * Only clients of this type.
 */
export type ClientType = ClosedEnum<typeof ClientType>;

export type ListAuthClientsRequest = {
  /**
   * Only clients offered by this MCP server.
   */
  mcpServerId?: string | undefined;
  /**
   * Only clients of this type.
   */
  clientType?: ClientType | undefined;
  /**
   * Pagination cursor.
   */
  cursor?: string | undefined;
  /**
   * Page size.
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

export type ListAuthClientsResponse = {
  result: ListAuthClientsResponseBody;
};

/** @internal */
export type ListAuthClientsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const ListAuthClientsSecurity$outboundSchema: z.ZodMiniType<
  ListAuthClientsSecurity$Outbound,
  ListAuthClientsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function listAuthClientsSecurityToJSON(
  listAuthClientsSecurity: ListAuthClientsSecurity,
): string {
  return JSON.stringify(
    ListAuthClientsSecurity$outboundSchema.parse(listAuthClientsSecurity),
  );
}

/** @internal */
export const ClientType$outboundSchema: z.ZodMiniEnum<typeof ClientType> = z
  .enum(ClientType);

/** @internal */
export type ListAuthClientsRequest$Outbound = {
  mcp_server_id?: string | undefined;
  client_type?: string | undefined;
  cursor?: string | undefined;
  limit: number;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
};

/** @internal */
export const ListAuthClientsRequest$outboundSchema: z.ZodMiniType<
  ListAuthClientsRequest$Outbound,
  ListAuthClientsRequest
> = z.pipe(
  z.object({
    mcpServerId: z.optional(z.string()),
    clientType: z.optional(ClientType$outboundSchema),
    cursor: z.optional(z.string()),
    limit: z._default(z.int(), 50),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServerId: "mcp_server_id",
      clientType: "client_type",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
    });
  }),
);

export function listAuthClientsRequestToJSON(
  listAuthClientsRequest: ListAuthClientsRequest,
): string {
  return JSON.stringify(
    ListAuthClientsRequest$outboundSchema.parse(listAuthClientsRequest),
  );
}

/** @internal */
export const ListAuthClientsResponse$inboundSchema: z.ZodMiniType<
  ListAuthClientsResponse,
  unknown
> = z.pipe(
  z.object({
    Result: ListAuthClientsResponseBody$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Result": "result",
    });
  }),
);

export function listAuthClientsResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListAuthClientsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAuthClientsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAuthClientsResponse' from JSON`,
  );
}
